/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 PRO React Base Styles
import colors from "assets/theme/base/colors";

const { transparent, info } = colors;

const textField = {
  styleOverrides: {
    root: {
      backgroundColor: transparent.main,
      "& .MuiInputLabel-root, & .MuiFormLabel-root, & .MuiFormHelperText-root": {
        color: "var(--app-text-secondary)",
      },
      "& .MuiInputLabel-root.Mui-focused, & .MuiFormLabel-root.Mui-focused": {
        color: info.main,
      },
      "& .MuiSvgIcon-root, & .material-icons, & .material-icons-round": {
        color: "var(--app-icon-color)",
      },
    },
  },
};

export default textField;
